import { render, staticRenderFns } from "./MetricValue.global.vue?vue&type=template&id=3d6ba01c&scoped=true&lang=pug&"
import script from "./MetricValue.global.vue?vue&type=script&lang=ts&"
export * from "./MetricValue.global.vue?vue&type=script&lang=ts&"
import style0 from "./MetricValue.global.vue?vue&type=style&index=0&id=3d6ba01c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3d6ba01c",
  null
  
)

export default component.exports